import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter, ApiSort } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils";
import { getErrorMessage } from "#/utils/APIUtils";

export const fetchLactationPeriodsForFinalPage = createAsyncThunk(
  "lactationCalculationsFinal/fetchByZivalId",
  async ({ zivalId, page = { page: 0, size: 100 } }, { rejectWithValue }) => {
    if (!zivalId) {
      throw new Error("zivalId is required");
    }

    const filter = new ApiFilter()
      .equal("zivalId", zivalId)
      .isNotNull("molza.id");
    try {
      const response = await ApiClient.get(
        "/api/zival/vwsamicemlecnost/page",
        undefined,
        page,
        filter,
        new ApiSort().sort("molza.zacetekMolzeDatum", "DESC")
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [fetchLactationPeriodsForFinalPage];

const lactationCalculationsFinalSlice = createSlice({
  name: "lactationCalculationsFinal",
  initialState: {
    page: {
      content: [],
      number: 0,
      totalElements: 0,
      totalPages: 0,
      size: 0,
    },
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchLactationPeriodsForFinalPage.fulfilled,
      (state, action) => {
        state.page = action.payload;
      }
    );
    handleLoadingAndErrorState(builder, thunks);
  },
});

export default lactationCalculationsFinalSlice.reducer;
